import { useMutation } from "react-query";
import { createTradeLicensePlate } from "store/api/api";
import { handleAxiosError } from "store/util";
import { Vehicle } from "types/types";
import { MUTATION_KEYS } from "../queryKeys";

const createTradeLicensePlateFn = async (params: Vehicle) => {
  return await createTradeLicensePlate(params);
};

export function useCreateTradeLicensePlate() {
  return useMutation(createTradeLicensePlateFn, {
    mutationKey: MUTATION_KEYS.createTradeLicensePlate,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
